<!--
* @Author : ShaJiaJing
* @Date :  2019/10/11
* @Version : 1.0
* @Content : 次要标题组件
-->
<template>
  <header>
    {{ title }}
    <div class="right">
      <slot name="right"></slot>
    </div>
  </header>
</template>

<script>
export default {
  name: 'BHeaderSecondary',
  props: {
    title: {
      type: String,
      default: '标题'
    }
  },
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  computed: {},
  methods: {}
}
</script>

<style lang="less" scoped>
header{
  border-left: 4px solid @primary;
  padding: 7px 0 7px 18px;
  color: @color-text-primary;
  font-size: @font-size-medium;
  line-height: @font-line-height-primary;
  background-color: @background-color-secondary;
  display: flex;
  justify-content: space-between;
  .right{
    height: @font-line-height-primary;
  }
}
</style>
